import React from 'react';
import { CheckIcon, WrenchIcon } from 'lucide-react';
import { modules } from '../../data/modules';
const features = ['Visual diagnostic workflows', 'Fault-finding sequences', 'Testing guides', 'Diagnostic decision trees', 'Scan-data references', 'Professional workshop tools'];
export function SystemOverview() {
  return <section className="bg-navy px-5 py-7 text-white" data-id="element-166" data-mp="3i06zfqimoxnx">
      <div className="mx-auto max-w-[520px]" data-id="element-167" data-mp="9jvc5l40dpkp">
        <h2 className="text-center font-display text-[21px] uppercase leading-[1.05] md:text-[24px]" data-id="element-168" data-mp="9kwxcieqnsg5">
          The complete <span className="text-gold" data-id="element-169" data-mp="el159k1kzeur">6-in-1</span> diagnostic system
        </h2>
        <p className="mt-0.5 flex items-center justify-center gap-1 font-display text-[11px] tracking-[0.05em] text-gold" data-id="element-170" data-mp="3vzg3xsxh23c2">
          <WrenchIcon className="h-3 w-3" aria-hidden="true" data-id="element-171" data-mp="sizigm46158o" /> DIESEL DIAGNOSTIC PRO™
        </p>
        <div className="mt-4 flex flex-col items-center md:ml-[46%] md:items-start" data-id="element-172" data-mp="x9pntzcld83d">
          <ul className="flex flex-wrap justify-center gap-1 md:justify-start" aria-label="Diagnostic areas" data-id="element-173" data-mp="xbsoddbdejmc">
            {modules.map(m => <li key={m.number} className="rounded-[2px] border border-gold bg-gold/10 px-1.5 py-[1px] font-display text-[9px] uppercase tracking-[0.05em] text-gold" data-id="element-174" data-mp="3kvfm9yl6eu24">
                {m.short}
              </li>)}
          </ul>
          <ul className="mt-3 space-y-1.5" data-id="element-175" data-mp="cebbqbn7bp75">
            {features.map(f => <li key={f} className="flex items-center gap-1.5 text-[11.5px] text-white/90" data-id="element-176" data-mp="7fqbic7y95ip">
                <CheckIcon className="h-3 w-3 shrink-0 text-ok" strokeWidth={3.5} aria-hidden="true" data-id="element-177" data-mp="lfixxvcg0zkv" />
                {f}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}